module.exports = require("katex");